function isRequired() {
    throw new Error('Function argument is required.');
}

module.exports = isRequired;
